// extracted by mini-css-extract-plugin
export default {"listCenters":"list_listCenters__5zonQ","header":"list_header__kb-Li","filters":"list_filters__ghVJm","rotate":"list_rotate__boWuM"};